<div class="modal-header">
  <div class="modal-title">
    <h3 class="mb-0">Change compliance type</h3>
    <p class="modal-subtitle mb-0">
      Pick the program this vendor should be evaluated against.
    </p>
  </div>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <div class="form-group mb-0">
    <label class="form-label" for="ccp-type">Compliance program</label>
    <select
      id="ccp-type"
      class="form-select"
      [(ngModel)]="CompanyComplianceTypeId"
    >
      <option disabled [ngValue]="undefined">Pick one…</option>
      @for (item of CompanyComplianceTypes; track item) {
        <option [ngValue]="item.id">
          {{ item.type }}
        </option>
      }
    </select>
  </div>
</div>

<div class="modal-footer">
  <div class="action-row justify-end w-100">
    <button type="button" class="btn btn-ghost" (click)="closeModal()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary" (click)="submit()">
      Save program
    </button>
  </div>
</div>
